import React from 'react'
import './Music_card.css'

import Music_option_modal from '../../modals/music-option-modal/Music_option_modal'
import Music_play_modal from '../../modals/music-play-modal/Music_play_modal'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { IDS } from '../../../../utils/IDS';

const Music_card = ({ music, musicList }) => {

    const [modalShow, setModalShow] = React.useState(false);
    const [modalShow2, setModalShow2] = React.useState(false);

    return (
        <>
            <div className="chant_card">
                <div className="main_div" onClick={() => setModalShow2(true)}>
                    <div className="pro_pic_div">
                        <img src={IDS.IMG_URL + music?.image} className="pro_pic" />
                    </div>
                    <div>
                        <p className="name_text">{music?.name || " "}</p>
                        <p className="sub_text">{music?.Chant_Type?.name || " "}</p>
                    </div>
                </div>

                <div className="more_div" onClick={() => setModalShow(true)}>
                    <FontAwesomeIcon icon={faEllipsisV} className="more_icon" />
                </div>
            </div>

            <Music_option_modal
                music={music}
                musicList={musicList}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            <Music_play_modal
                musicList={musicList}
                music={music}
                show={modalShow2}
                onHide={() => setModalShow2(false)}
            />

        </>
    )
}

export default Music_card
// import React from 'react'
// import './Music_card.css'

// import Music_option_modal from '../../modals/music-option-modal/Music_option_modal'
// import Music_play_modal from '../../modals/music-play-modal/Music_play_modal'
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

// const Music_card = ({ music }) => {

//     const [modalShow, setModalShow] = React.useState(false);
//     const [modalShow2, setModalShow2] = React.useState(false);

//     return (
//         <>
//             <div className="chant_card">
//                 <div className="main_div" onClick={() => setModalShow2(true)}>
//                     <div className="pro_pic_div">
//                         <img src="/assets/images/home/chants/baba.png" className="pro_pic" />
//                     </div>
//                     <div>
//                         <p className="name_text">Nirvana Shatakam</p>
//                         <p className="sub_text">Vairagya Reprise</p>
//                     </div>
//                 </div>

//                 <div className="more_div" onClick={() => setModalShow(true)}>
//                     <FontAwesomeIcon icon={faEllipsisV} className="more_icon" />
//                 </div>
//             </div>

//             <Music_option_modal
//                 show={modalShow}
//                 onHide={() => setModalShow(false)}
//             />
//             <Music_play_modal
//                 show={modalShow2}
//                 onHide={() => setModalShow2(false)}
//             />

//         </>
//     )
// }

// export default Music_card